import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _34e8de24 = () => interopDefault(import('../../../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _3b67ae19 = () => interopDefault(import('../../../pages/android.vue' /* webpackChunkName: "pages/android" */))
const _5c146542 = () => interopDefault(import('../../../pages/careers.vue' /* webpackChunkName: "pages/careers" */))
const _08909130 = () => interopDefault(import('../../../pages/experience.vue' /* webpackChunkName: "pages/experience" */))
const _e8df357e = () => interopDefault(import('../../../pages/financing.vue' /* webpackChunkName: "pages/financing" */))
const _ffe107fa = () => interopDefault(import('../../../pages/how-it-works.vue' /* webpackChunkName: "pages/how-it-works" */))
const _13c35837 = () => interopDefault(import('../../../pages/id-verification.vue' /* webpackChunkName: "pages/id-verification" */))
const _022a82e1 = () => interopDefault(import('../../../pages/journal.vue' /* webpackChunkName: "pages/journal" */))
const _6888e643 = () => interopDefault(import('../../../pages/kickboxing.vue' /* webpackChunkName: "pages/kickboxing" */))
const _a20263c6 = () => interopDefault(import('../../../pages/legal-terms.vue' /* webpackChunkName: "pages/legal-terms" */))
const _62cab45f = () => interopDefault(import('../../../pages/lifestyle.vue' /* webpackChunkName: "pages/lifestyle" */))
const _52ab0341 = () => interopDefault(import('../../../pages/partner-offer.vue' /* webpackChunkName: "pages/partner-offer" */))
const _8627e326 = () => interopDefault(import('../../../pages/press.vue' /* webpackChunkName: "pages/press" */))
const _606593f0 = () => interopDefault(import('../../../pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _5c1e355d = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _30a642ce = () => interopDefault(import('../../../pages/return-policy.vue' /* webpackChunkName: "pages/return-policy" */))
const _a8095226 = () => interopDefault(import('../../../pages/returns.vue' /* webpackChunkName: "pages/returns" */))
const _f8675e82 = () => interopDefault(import('../../../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _32e32b01 = () => interopDefault(import('../../../pages/trackers.vue' /* webpackChunkName: "pages/trackers" */))
const _09dc0b41 = () => interopDefault(import('../../../pages/what-is-fightcamp.vue' /* webpackChunkName: "pages/what-is-fightcamp" */))
const _36178106 = () => interopDefault(import('../../../pages/why-choose-fightcamp.vue' /* webpackChunkName: "pages/why-choose-fightcamp" */))
const _0657278b = () => interopDefault(import('../../../pages/why-it-works.vue' /* webpackChunkName: "pages/why-it-works" */))
const _57a016bc = () => interopDefault(import('../../../pages/workouts.vue' /* webpackChunkName: "pages/workouts" */))
const _b940cf46 = () => interopDefault(import('../../../pages/shop/accessories.vue' /* webpackChunkName: "pages/shop/accessories" */))
const _7862bb2e = () => interopDefault(import('../../../pages/shop/checkout.vue' /* webpackChunkName: "pages/shop/checkout" */))
const _08ef1458 = () => interopDefault(import('../../../pages/shop/confirmation.vue' /* webpackChunkName: "pages/shop/confirmation" */))
const _f1af0c10 = () => interopDefault(import('../../../pages/shop/marketplace.vue' /* webpackChunkName: "pages/shop/marketplace" */))
const _10ce4150 = () => interopDefault(import('../../../pages/shop/partner/checkout.vue' /* webpackChunkName: "pages/shop/partner/checkout" */))
const _b05291ee = () => interopDefault(import('../../../pages/shop/products/fightcamp.vue' /* webpackChunkName: "pages/shop/products/fightcamp" */))
const _4213a2a6 = () => interopDefault(import('../../../pages/shop/products/fightcamp-complete.vue' /* webpackChunkName: "pages/shop/products/fightcamp-complete" */))
const _2c9bbba6 = () => interopDefault(import('../../../pages/shop/products/fightcamp-connect.vue' /* webpackChunkName: "pages/shop/products/fightcamp-connect" */))
const _53882993 = () => interopDefault(import('../../../pages/shop/products/fightcamp-console.vue' /* webpackChunkName: "pages/shop/products/fightcamp-console" */))
const _e9899462 = () => interopDefault(import('../../../pages/shop/products/fightcamp-elite.vue' /* webpackChunkName: "pages/shop/products/fightcamp-elite" */))
const _8a0086a2 = () => interopDefault(import('../../../pages/shop/products/fightcamp-trackers.vue' /* webpackChunkName: "pages/shop/products/fightcamp-trackers" */))
const _0a4c68fc = () => interopDefault(import('../../../pages/shop/products/_slug.vue' /* webpackChunkName: "pages/shop/products/_slug" */))
const _79ed3c05 = () => interopDefault(import('../../../pages/lp/_slug.vue' /* webpackChunkName: "pages/lp/_slug" */))
const _79f69908 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _e4fb1706 = () => interopDefault(import('../../../pages/_preview/confirmation-view.vue' /* webpackChunkName: "pages/_preview/confirmation-view" */))
const _1a56310d = () => interopDefault(import('../../../pages/_preview/sand-delivery-upsell.vue' /* webpackChunkName: "pages/_preview/sand-delivery-upsell" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _34e8de24,
    name: "about-us"
  }, {
    path: "/android",
    component: _3b67ae19,
    name: "android"
  }, {
    path: "/careers",
    component: _5c146542,
    name: "careers"
  }, {
    path: "/experience",
    component: _08909130,
    name: "experience"
  }, {
    path: "/financing",
    component: _e8df357e,
    name: "financing"
  }, {
    path: "/how-it-works",
    component: _ffe107fa,
    name: "how-it-works"
  }, {
    path: "/id-verification",
    component: _13c35837,
    name: "id-verification"
  }, {
    path: "/journal",
    component: _022a82e1,
    name: "journal"
  }, {
    path: "/kickboxing",
    component: _6888e643,
    name: "kickboxing"
  }, {
    path: "/legal-terms",
    component: _a20263c6,
    name: "legal-terms"
  }, {
    path: "/lifestyle",
    component: _62cab45f,
    name: "lifestyle"
  }, {
    path: "/partner-offer",
    component: _52ab0341,
    name: "partner-offer"
  }, {
    path: "/press",
    component: _8627e326,
    name: "press"
  }, {
    path: "/pricing",
    component: _606593f0,
    name: "pricing"
  }, {
    path: "/privacy-policy",
    component: _5c1e355d,
    name: "privacy-policy"
  }, {
    path: "/return-policy",
    component: _30a642ce,
    name: "return-policy"
  }, {
    path: "/returns",
    component: _a8095226,
    name: "returns"
  }, {
    path: "/shop",
    component: _f8675e82,
    name: "shop"
  }, {
    path: "/trackers",
    component: _32e32b01,
    name: "trackers"
  }, {
    path: "/what-is-fightcamp",
    component: _09dc0b41,
    name: "what-is-fightcamp"
  }, {
    path: "/why-choose-fightcamp",
    component: _36178106,
    name: "why-choose-fightcamp"
  }, {
    path: "/why-it-works",
    component: _0657278b,
    name: "why-it-works"
  }, {
    path: "/workouts",
    component: _57a016bc,
    name: "workouts"
  }, {
    path: "/shop/accessories",
    component: _b940cf46,
    name: "shop-accessories"
  }, {
    path: "/shop/checkout",
    component: _7862bb2e,
    name: "shop-checkout"
  }, {
    path: "/shop/confirmation",
    component: _08ef1458,
    name: "shop-confirmation"
  }, {
    path: "/shop/marketplace",
    component: _f1af0c10,
    name: "shop-marketplace"
  }, {
    path: "/shop/partner/checkout",
    component: _10ce4150,
    name: "shop-partner-checkout"
  }, {
    path: "/shop/products/fightcamp",
    component: _b05291ee,
    name: "shop-products-fightcamp"
  }, {
    path: "/shop/products/fightcamp-complete",
    component: _4213a2a6,
    name: "shop-products-fightcamp-complete"
  }, {
    path: "/shop/products/fightcamp-connect",
    component: _2c9bbba6,
    name: "shop-products-fightcamp-connect"
  }, {
    path: "/shop/products/fightcamp-console",
    component: _53882993,
    name: "shop-products-fightcamp-console"
  }, {
    path: "/shop/products/fightcamp-elite",
    component: _e9899462,
    name: "shop-products-fightcamp-elite"
  }, {
    path: "/shop/products/fightcamp-trackers",
    component: _8a0086a2,
    name: "shop-products-fightcamp-trackers"
  }, {
    path: "/shop/products/:slug?",
    component: _0a4c68fc,
    name: "shop-products-slug"
  }, {
    path: "/lp/:slug?",
    component: _79ed3c05,
    name: "lp-slug"
  }, {
    path: "/",
    component: _79f69908,
    name: "index"
  }, {
    path: "/:preview/confirmation-view",
    component: _e4fb1706,
    name: "preview-confirmation-view"
  }, {
    path: "/:preview/sand-delivery-upsell",
    component: _1a56310d,
    name: "preview-sand-delivery-upsell"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
